import React from 'react'

const StarFill = props => (
  <svg
    viewBox='0 0 16 15'
    width={props.width || '16px'}
    height={props.height || '15px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill={props.color || '#C1C1C1'} fillRule='nonzero'>
        <path d='M12.4454887,14.9961243 C12.3172764,14.9966321 12.1908103,14.966866 12.0767015,14.9093234 L7.98797433,12.8024291 L3.89924715,14.9093234 C3.6283757,15.0495172 3.3000445,15.0256974 3.05298381,14.8479288 C2.80592312,14.6701602 2.68323765,14.3694581 2.73676589,14.0728785 L3.5384771,9.6302511 L0.235426911,6.47385509 C0.0254236534,6.26758546 -0.0516783789,5.96402909 0.0349991084,5.68475609 C0.129796759,5.39864605 0.381677417,5.19051722 0.68438519,5.14816877 L5.2541391,4.4932166 L7.26643424,0.445138721 C7.40038932,0.172907197 7.68066032,0 7.98797433,0 C8.29528835,0 8.57555935,0.172907197 8.70951442,0.445138721 L10.7458609,4.48532561 L15.3156148,5.14027778 C15.6183226,5.18262623 15.8702032,5.39075506 15.9650009,5.6768651 C16.0516784,5.9561381 15.9745763,6.25969447 15.7645731,6.4659641 L12.4615229,9.62236011 L13.2632341,14.0649875 C13.3216732,14.3670523 13.1965178,14.6750187 12.9425496,14.8540865 C12.7973741,14.9542205 12.6225734,15.0041707 12.4454887,14.9961243 L12.4454887,14.9961243 Z' />
      </g>
    </g>
  </svg>
)

export default StarFill
